import React from 'react'
import { Link } from 'gatsby'
import * as styles from './header.module.css'

const Header = ({ journal }) => {
  return (
    <header style={{ color: journal ? '#000' : '#fff' }}>
      <Link to='/' className={styles.headerLogo}>
        <svg
          viewBox='0 0 290 290'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          className={styles.logoCircle}
        >
          <path
            d='M142.481 0.133308L138.084 0.279358L138.904 24.9645L143.301 24.8185L142.481 0.133308Z'
            fill='currentColor'
          />
          <path
            d='M129.904 0.92067L125.536 1.44867L128.5 25.9708L132.868 25.4428L129.904 0.92067Z'
            fill='currentColor'
          />
          <path
            d='M117.401 2.8127L113.095 3.71954L118.186 27.8885L122.492 26.9817L117.401 2.8127Z'
            fill='currentColor'
          />
          <path
            d='M105.208 5.77507L100.998 7.05371L108.176 30.6867L112.386 29.408L105.208 5.77507Z'
            fill='currentColor'
          />
          <path
            d='M93.2544 9.85011L89.1717 11.4909L98.3823 34.41L102.465 32.7692L93.2544 9.85011Z'
            fill='currentColor'
          />
          <path
            d='M81.6602 14.8262L77.7358 16.8163L88.9077 38.8462L92.832 36.8561L81.6602 14.8262Z'
            fill='currentColor'
          />
          <path
            d='M70.5427 20.914L66.8067 23.2385L79.8557 44.2113L83.5917 41.8868L70.5427 20.914Z'
            fill='currentColor'
          />
          <path
            d='M60.0207 27.8655L56.5016 30.5068L71.329 50.2619L74.8481 47.6205L60.0207 27.8655Z'
            fill='currentColor'
          />
          <path
            d='M50.2003 35.7817L46.9249 38.7196L63.4171 57.1063L66.6925 54.1684L50.2003 35.7817Z'
            fill='currentColor'
          />
          <path
            d='M41.1021 44.4707L38.0952 47.6831L56.1286 64.5631L59.1356 61.3507L41.1021 44.4707Z'
            fill='currentColor'
          />
          <path
            d='M32.6964 53.8979L29.9807 57.3599L49.4147 72.6047L52.1303 69.1428L32.6964 53.8979Z'
            fill='currentColor'
          />
          <path
            d='M25.211 64.0533L22.8077 67.7387L43.4964 81.2299L45.8997 77.5444L25.211 64.0533Z'
            fill='currentColor'
          />
          <path
            d='M18.6723 74.8871L16.5995 78.7683L38.3873 90.4045L40.4602 86.5232L18.6723 74.8871Z'
            fill='currentColor'
          />
          <path
            d='M13.0838 86.1218L11.3568 90.1689L34.0758 99.8637L35.8028 95.8165L13.0838 86.1218Z'
            fill='currentColor'
          />
          <path
            d='M8.451 97.9172L7.08348 102.099L30.5608 109.776L31.9283 105.594L8.451 97.9172Z'
            fill='currentColor'
          />
          <path
            d='M4.86242 110.035L3.8645 114.321L27.9198 119.923L28.9178 115.637L4.86242 110.035Z'
            fill='currentColor'
          />
          <path
            d='M2.43206 122.409L1.81122 126.765L26.2642 130.251L26.8851 125.895L2.43206 122.409Z'
            fill='currentColor'
          />
          <path
            d='M0.939561 134.93L0.700806 139.324L25.3638 140.664L25.6025 136.271L0.939561 134.93Z'
            fill='currentColor'
          />
          <path
            d='M25.3208 146.785L0.63559 147.605L0.781635 152.003L25.4668 151.183L25.3208 146.785Z'
            fill='currentColor'
          />
          <path
            d='M26.0517 157.233L1.52954 160.197L2.05754 164.565L26.5797 161.601L26.0517 157.233Z'
            fill='currentColor'
          />
          <path
            d='M27.5681 167.487L3.39911 172.576L4.30551 176.881L28.4745 171.793L27.5681 167.487Z'
            fill='currentColor'
          />
          <path
            d='M29.9248 177.728L6.28935 184.903L7.56756 189.113L31.203 181.938L29.9248 177.728Z'
            fill='currentColor'
          />
          <path
            d='M33.2943 187.65L10.3752 196.858L12.0155 200.941L34.9346 191.733L33.2943 187.65Z'
            fill='currentColor'
          />
          <path
            d='M37.4845 197.242L15.4546 208.414L17.4447 212.338L39.4746 201.166L37.4845 197.242Z'
            fill='currentColor'
          />
          <path
            d='M42.4621 206.394L21.4893 219.443L23.8139 223.179L44.7866 210.13L42.4621 206.394Z'
            fill='currentColor'
          />
          <path
            d='M48.187 215.134L28.432 229.962L31.0733 233.481L50.8283 218.653L48.187 215.134Z'
            fill='currentColor'
          />
          <path
            d='M54.7201 223.417L36.3334 239.909L39.2713 243.184L57.658 226.692L54.7201 223.417Z'
            fill='currentColor'
          />
          <path
            d='M61.9288 230.975L45.0488 249.008L48.2612 252.015L65.1412 233.982L61.9288 230.975Z'
            fill='currentColor'
          />
          <path
            d='M69.7629 237.909L54.518 257.343L57.98 260.059L73.2248 240.625L69.7629 237.909Z'
            fill='currentColor'
          />
          <path
            d='M78.1655 244.109L64.6744 264.798L68.3598 267.201L81.851 246.512L78.1655 244.109Z'
            fill='currentColor'
          />
          <path
            d='M87.0145 249.606L75.3758 271.391L79.2567 273.464L90.8953 251.679L87.0145 249.606Z'
            fill='currentColor'
          />
          <path
            d='M96.4175 254.296L86.7227 277.016L90.7699 278.743L100.465 256.023L96.4175 254.296Z'
            fill='currentColor'
          />
          <path
            d='M106.179 258.157L98.4995 281.632L102.681 283L110.36 259.525L106.179 258.157Z'
            fill='currentColor'
          />
          <path
            d='M116.163 261.038L110.556 285.094L114.841 286.092L120.448 262.037L116.163 261.038Z'
            fill='currentColor'
          />
          <path
            d='M126.407 263.178L122.917 287.631L127.273 288.252L130.763 263.799L126.407 263.178Z'
            fill='currentColor'
          />
          <path
            d='M136.881 264.371L135.535 289.034L139.929 289.274L141.275 264.611L136.881 264.371Z'
            fill='currentColor'
          />
          <path
            d='M151.699 264.546L147.301 264.691L148.117 289.379L152.515 289.233L151.699 264.546Z'
            fill='currentColor'
          />
          <path
            d='M162.115 263.525L157.747 264.053L160.711 288.575L165.079 288.047L162.115 263.525Z'
            fill='currentColor'
          />
          <path
            d='M172.393 261.599L168.088 262.505L173.176 286.674L177.482 285.768L172.393 261.599Z'
            fill='currentColor'
          />
          <path
            d='M182.512 258.793L178.301 260.071L185.477 283.707L189.687 282.429L182.512 258.793Z'
            fill='currentColor'
          />
          <path
            d='M192.236 255.071L188.153 256.711L197.364 279.631L201.447 277.99L192.236 255.071Z'
            fill='currentColor'
          />
          <path
            d='M201.706 250.644L197.782 252.635L208.953 274.664L212.878 272.674L201.706 250.644Z'
            fill='currentColor'
          />
          <path
            d='M210.758 245.284L207.022 247.608L220.071 268.581L223.807 266.257L210.758 245.284Z'
            fill='currentColor'
          />
          <path
            d='M219.219 239.14L215.7 241.782L230.528 261.537L234.047 258.896L219.219 239.14Z'
            fill='currentColor'
          />
          <path
            d='M227.173 232.353L223.898 235.291L240.39 253.678L243.666 250.74L227.173 232.353Z'
            fill='currentColor'
          />
          <path
            d='M234.487 224.913L231.48 228.125L249.514 245.005L252.521 241.793L234.487 224.913Z'
            fill='currentColor'
          />
          <path
            d='M241.104 216.832L238.388 220.294L257.822 235.539L260.538 232.077L241.104 216.832Z'
            fill='currentColor'
          />
          <path
            d='M247.104 208.228L244.701 211.914L265.392 225.405L267.795 221.719L247.104 208.228Z'
            fill='currentColor'
          />
          <path
            d='M252.208 199.077L250.135 202.957L271.92 214.596L273.993 210.715L252.208 199.077Z'
            fill='currentColor'
          />
          <path
            d='M256.575 189.509L254.848 193.556L277.567 203.251L279.294 199.204L256.575 189.509Z'
            fill='currentColor'
          />
          <path
            d='M260.031 179.675L258.664 183.857L282.141 191.534L283.509 187.351L260.031 179.675Z'
            fill='currentColor'
          />
          <path
            d='M262.657 169.557L261.659 173.842L285.714 179.444L286.712 175.159L262.657 169.557Z'
            fill='currentColor'
          />
          <path
            d='M264.312 159.213L263.692 163.569L288.145 167.052L288.765 162.696L264.312 159.213Z'
            fill='currentColor'
          />
          <path
            d='M265.111 148.801L264.873 153.195L289.536 154.535L289.774 150.142L265.111 148.801Z'
            fill='currentColor'
          />
          <path
            d='M289.735 137.601L265.048 138.416L265.193 142.814L289.881 141.999L289.735 137.601Z'
            fill='currentColor'
          />
          <path
            d='M288.563 125.031L264.041 127.995L264.569 132.363L289.091 129.399L288.563 125.031Z'
            fill='currentColor'
          />
          <path
            d='M286.279 112.597L262.111 117.688L263.017 121.994L287.186 116.903L286.279 112.597Z'
            fill='currentColor'
          />
          <path
            d='M282.936 100.434L259.3 107.609L260.578 111.82L284.214 104.645L282.936 100.434Z'
            fill='currentColor'
          />
          <path
            d='M278.587 88.5421L255.668 97.7527L257.309 101.836L280.228 92.6249L278.587 88.5421Z'
            fill='currentColor'
          />
          <path
            d='M273.169 77.1522L251.139 88.324L253.129 92.2484L275.159 81.0766L273.169 77.1522Z'
            fill='currentColor'
          />
          <path
            d='M266.8 66.3165L245.827 79.3655L248.152 83.1016L269.125 70.0526L266.8 66.3165Z'
            fill='currentColor'
          />
          <path
            d='M259.529 56.0085L239.774 70.8359L242.415 74.355L262.17 59.5276L259.529 56.0085Z'
            fill='currentColor'
          />
          <path
            d='M251.306 46.4383L232.919 62.9305L235.857 66.2058L254.244 49.7137L251.306 46.4383Z'
            fill='currentColor'
          />
          <path
            d='M242.427 37.5172L225.547 55.5506L228.76 58.5576L245.64 40.5241L242.427 37.5172Z'
            fill='currentColor'
          />
          <path
            d='M232.697 29.5015L217.452 48.9355L220.914 51.6511L236.159 32.2172L232.697 29.5015Z'
            fill='currentColor'
          />
          <path
            d='M222.301 22.3267L208.81 43.0154L212.495 45.4187L225.986 24.73L222.301 22.3267Z'
            fill='currentColor'
          />
          <path
            d='M211.32 16.0054L199.684 37.7932L203.565 39.8661L215.202 18.0782L211.32 16.0054Z'
            fill='currentColor'
          />
          <path
            d='M199.803 10.8105L190.108 33.5295L194.155 35.2565L203.85 12.5375L199.803 10.8105Z'
            fill='currentColor'
          />
          <path
            d='M187.959 6.58509L180.284 30.0624L184.467 31.4295L192.141 7.95217L187.959 6.58509Z'
            fill='currentColor'
          />
          <path
            d='M175.736 3.35798L170.137 27.4158L174.422 28.4133L180.022 4.35545L175.736 3.35798Z'
            fill='currentColor'
          />
          <path
            d='M163.313 1.20778L159.831 25.6608L164.187 26.2812L167.669 1.82818L163.313 1.20778Z'
            fill='currentColor'
          />
          <path
            d='M150.746 0.201784L149.407 24.8647L153.8 25.1032L155.139 0.440263L150.746 0.201784Z'
            fill='currentColor'
          />
          <path
            d='M143.094 33.9531L139.796 34.062L140.42 52.9526L143.718 52.8436L143.094 33.9531Z'
            fill='currentColor'
          />
          <path
            d='M133.459 34.5752L130.183 34.9709L132.449 53.7348L135.725 53.3391L133.459 34.5752Z'
            fill='currentColor'
          />
          <path
            d='M123.907 35.9605L120.678 36.6409L124.575 55.1346L127.805 54.4541L123.907 35.9605Z'
            fill='currentColor'
          />
          <path
            d='M114.474 38.2425L111.316 39.2012L116.806 57.2866L119.964 56.3279L114.474 38.2425Z'
            fill='currentColor'
          />
          <path
            d='M105.357 41.3612L102.295 42.5914L109.341 60.1287L112.403 58.8985L105.357 41.3612Z'
            fill='currentColor'
          />
          <path
            d='M96.4269 45.1972L93.4836 46.6898L102.032 63.5467L104.975 62.0541L96.4269 45.1972Z'
            fill='currentColor'
          />
          <path
            d='M87.9503 49.8751L85.1486 51.6185L95.1335 67.6646L97.9352 65.9212L87.9503 49.8751Z'
            fill='currentColor'
          />
          <path
            d='M79.8947 55.2338L77.2554 57.2148L88.601 72.331L91.2404 70.35L79.8947 55.2338Z'
            fill='currentColor'
          />
          <path
            d='M72.34 61.2345L69.8835 63.4379L82.503 77.5071L84.9595 75.3037L72.34 61.2345Z'
            fill='currentColor'
          />
          <path
            d='M65.3467 67.911L63.0915 70.32L76.8885 83.2363L79.1437 80.8273L65.3467 67.911Z'
            fill='currentColor'
          />
          <path
            d='M58.9829 75.2602L56.9462 77.8566L71.8167 89.5217L73.8534 86.9253L58.9829 75.2602Z'
            fill='currentColor'
          />
          <path
            d='M53.1876 82.9567L51.3851 85.7208L67.2158 96.044L69.0182 93.2799L53.1876 82.9567Z'
            fill='currentColor'
          />
          <path
            d='M48.2226 91.272L46.6676 94.1826L63.3374 103.088L64.8924 100.178L48.2226 91.272Z'
            fill='currentColor'
          />
          <path
            d='M43.9585 99.9285L42.6632 102.964L60.0474 110.382L61.3427 107.347L43.9585 99.9285Z'
            fill='currentColor'
          />
          <path
            d='M40.3554 108.899L39.3298 112.036L57.2943 117.91L58.3199 114.774L40.3554 108.899Z'
            fill='currentColor'
          />
          <path
            d='M37.6924 118.24L36.944 121.454L55.3507 125.74L56.0991 122.526L37.6924 118.24Z'
            fill='currentColor'
          />
          <path
            d='M35.8055 127.71L35.3399 130.977L54.0509 133.643L54.5165 130.376L35.8055 127.71Z'
            fill='currentColor'
          />
          <path
            d='M34.7312 137.264L34.5522 140.559L53.4239 141.584L53.6028 138.289L34.7312 137.264Z'
            fill='currentColor'
          />
          <path
            d='M53.3427 146.296L34.4521 146.92L34.5611 150.219L53.4516 149.595L53.3427 146.296Z'
            fill='currentColor'
          />
          <path
            d='M53.826 154.285L35.0621 156.552L35.4578 159.828L54.2217 157.562L53.826 154.285Z'
            fill='currentColor'
          />
          <path
            d='M55.054 162.186L36.5585 166.078L37.238 169.307L55.7335 165.416L55.054 162.186Z'
            fill='currentColor'
          />
          <path
            d='M56.9154 170.028L38.83 175.52L39.789 178.678L57.8744 173.186L56.9154 170.028Z'
            fill='currentColor'
          />
          <path
            d='M59.3947 177.612L41.8574 184.66L43.088 187.722L60.6253 180.674L59.3947 177.612Z'
            fill='currentColor'
          />
          <path
            d='M62.6317 184.999L45.7766 193.549L47.2696 196.492L64.1246 187.942L62.6317 184.999Z'
            fill='currentColor'
          />
          <path
            d='M66.4097 192.082L50.3617 202.065L52.1048 204.867L68.1528 194.884L66.4097 192.082Z'
            fill='currentColor'
          />
          <path
            d='M70.8373 198.78L55.7248 210.129L57.7065 212.768L72.8189 201.418L70.8373 198.78Z'
            fill='currentColor'
          />
          <path
            d='M75.8857 205.011L61.8127 217.629L64.0158 220.086L78.0888 207.469L75.8857 205.011Z'
            fill='currentColor'
          />
          <path
            d='M81.3935 210.817L68.4735 224.612L70.8822 226.868L83.8022 213.073L81.3935 210.817Z'
            fill='currentColor'
          />
          <path
            d='M87.3344 216.124L75.6693 230.994L78.2657 233.031L89.9308 218.16L87.3344 216.124Z'
            fill='currentColor'
          />
          <path
            d='M93.8162 220.943L83.493 236.773L86.2571 238.576L96.5802 222.745L93.8162 220.943Z'
            fill='currentColor'
          />
          <path
            d='M100.659 225.165L91.7532 241.835L94.6638 243.39L103.57 226.72L100.659 225.165Z'
            fill='currentColor'
          />
          <path
            d='M107.843 228.732L100.426 246.116L103.462 247.411L110.878 230.027L107.843 228.732Z'
            fill='currentColor'
          />
          <path
            d='M115.309 231.649L109.431 249.611L112.567 250.637L118.445 232.675L115.309 231.649Z'
            fill='currentColor'
          />
          <path
            d='M122.919 233.937L118.632 252.344L121.846 253.093L126.133 234.686L122.919 233.937Z'
            fill='currentColor'
          />
          <path
            d='M130.881 235.563L128.214 254.274L131.481 254.739L134.148 236.028L130.881 235.563Z'
            fill='currentColor'
          />
          <path
            d='M138.792 236.466L137.763 255.338L141.058 255.517L142.087 236.646L138.792 236.466Z'
            fill='currentColor'
          />
          <path
            d='M150.094 236.563L146.796 236.672L147.42 255.563L150.718 255.454L150.094 236.563Z'
            fill='currentColor'
          />
          <path
            d='M158.161 235.769L154.885 236.165L157.153 254.929L160.429 254.533L158.161 235.769Z'
            fill='currentColor'
          />
          <path
            d='M166.019 234.26L162.79 234.94L166.681 253.435L169.911 252.756L166.019 234.26Z'
            fill='currentColor'
          />
          <path
            d='M173.668 232.165L170.51 233.123L176 251.209L179.158 250.25L173.668 232.165Z'
            fill='currentColor'
          />
          <path
            d='M181.252 229.369L178.19 230.6L185.236 248.137L188.298 246.907L181.252 229.369Z'
            fill='currentColor'
          />
          <path
            d='M188.446 225.904L185.503 227.397L194.051 244.253L196.994 242.761L188.446 225.904Z'
            fill='currentColor'
          />
          <path
            d='M195.361 221.87L192.56 223.613L202.544 239.659L205.346 237.916L195.361 221.87Z'
            fill='currentColor'
          />
          <path
            d='M201.928 217.207L199.289 219.188L210.635 234.304L213.274 232.323L201.928 217.207Z'
            fill='currentColor'
          />
          <path
            d='M207.946 211.954L205.489 214.157L218.109 228.226L220.565 226.023L207.946 211.954Z'
            fill='currentColor'
          />
          <path
            d='M213.555 206.26L211.3 208.669L225.097 221.586L227.352 219.177L213.555 206.26Z'
            fill='currentColor'
          />
          <path
            d='M218.717 200.017L216.68 202.614L231.553 214.277L233.589 211.68L218.717 200.017Z'
            fill='currentColor'
          />
          <path
            d='M223.245 193.447L221.442 196.211L237.275 206.534L239.077 203.77L223.245 193.447Z'
            fill='currentColor'
          />
          <path
            d='M227.205 186.493L225.65 189.404L242.32 198.31L243.875 195.399L227.205 186.493Z'
            fill='currentColor'
          />
          <path
            d='M230.523 179.173L229.227 182.209L246.612 189.627L247.907 186.592L230.523 179.173Z'
            fill='currentColor'
          />
          <path
            d='M233.168 171.597L232.143 174.733L250.107 180.608L251.133 177.471L233.168 171.597Z'
            fill='currentColor'
          />
          <path
            d='M235.201 163.833L234.453 167.047L252.859 171.333L253.608 168.119L235.201 163.833Z'
            fill='currentColor'
          />
          <path
            d='M236.52 155.927L236.054 159.194L254.765 161.859L255.231 158.592L236.52 155.927Z'
            fill='currentColor'
          />
          <path
            d='M237.152 147.886L236.972 151.181L255.844 152.207L256.023 148.912L237.152 147.886Z'
            fill='currentColor'
          />
          <path
            d='M255.953 139.297L237.062 139.921L237.171 143.219L256.062 142.595L255.953 139.297Z'
            fill='currentColor'
          />
          <path
            d='M255.027 129.598L236.263 131.864L236.659 135.14L255.423 132.874L255.027 129.598Z'
            fill='currentColor'
          />
          <path
            d='M253.345 120.09L234.852 123.987L235.532 127.216L254.026 123.319L253.345 120.09Z'
            fill='currentColor'
          />
          <path
            d='M250.835 110.818L232.75 116.31L233.709 119.468L251.794 113.975L250.835 110.818Z'
            fill='currentColor'
          />
          <path
            d='M247.4 101.701L229.862 108.749L231.093 111.811L248.63 104.763L247.4 101.701Z'
            fill='currentColor'
          />
          <path
            d='M243.328 92.982L226.473 101.532L227.966 104.475L244.821 95.925L243.328 92.982Z'
            fill='currentColor'
          />
          <path
            d='M238.407 84.6524L222.361 94.6392L224.105 97.4409L240.151 87.4541L238.407 84.6524Z'
            fill='currentColor'
          />
          <path
            d='M232.808 76.7513L217.695 88.1007L219.677 90.7394L234.789 79.39L232.808 76.7513Z'
            fill='currentColor'
          />
          <path
            d='M226.609 69.3886L212.536 82.0063L214.739 84.4634L228.812 71.8458L226.609 69.3886Z'
            fill='currentColor'
          />
          <path
            d='M219.646 62.5454L206.73 76.3423L209.139 78.5976L222.055 64.8006L219.646 62.5454Z'
            fill='currentColor'
          />
          <path
            d='M212.187 56.4527L200.522 71.3232L203.119 73.3599L214.784 58.4894L212.187 56.4527Z'
            fill='currentColor'
          />
          <path
            d='M204.28 50.9788L193.951 66.8076L196.715 68.611L207.044 52.7823L204.28 50.9788Z'
            fill='currentColor'
          />
          <path
            d='M195.874 46.1728L186.974 62.8463L189.885 64.4003L198.785 47.7267L195.874 46.1728Z'
            fill='currentColor'
          />
          <path
            d='M187.098 42.1667L179.682 59.5509L182.717 60.8458L190.134 43.4616L187.098 42.1667Z'
            fill='currentColor'
          />
          <path
            d='M178.021 38.8339L172.148 56.7984L175.285 57.8237L181.157 39.8592L178.021 38.8339Z'
            fill='currentColor'
          />
          <path
            d='M168.608 36.456L164.322 54.8627L167.535 55.6111L171.822 37.2044L168.608 36.456Z'
            fill='currentColor'
          />
          <path
            d='M159.102 34.8362L156.436 53.5472L159.703 54.0128L162.369 35.3018L159.102 34.8362Z'
            fill='currentColor'
          />
          <path
            d='M149.414 34.0455L148.385 52.9172L151.68 53.0968L152.709 34.2251L149.414 34.0455Z'
            fill='currentColor'
          />
          <path
            d='M143.671 61.3654L141.172 61.448L141.641 75.6409L144.14 75.5582L143.671 61.3654Z'
            fill='currentColor'
          />
          <path
            d='M136.435 61.8031L133.953 62.1031L135.657 76.2009L138.139 75.9009L136.435 61.8031Z'
            fill='currentColor'
          />
          <path
            d='M129.197 62.8897L126.75 63.405L129.677 77.2997L132.123 76.7844L129.197 62.8897Z'
            fill='currentColor'
          />
          <path
            d='M122.09 64.6571L119.698 65.3836L123.825 78.9716L126.217 78.2451L122.09 64.6571Z'
            fill='currentColor'
          />
          <path
            d='M115.254 66.9388L112.934 67.8711L118.229 81.0472L120.549 80.115L115.254 66.9388Z'
            fill='currentColor'
          />
          <path
            d='M108.553 69.915L106.323 71.0457L112.746 83.7093L114.975 82.5785L108.553 69.915Z'
            fill='currentColor'
          />
          <path
            d='M102.137 73.3443L100.014 74.665L107.516 86.7222L109.639 85.4015L102.137 73.3443Z'
            fill='currentColor'
          />
          <path
            d='M96.0823 77.4096L94.0828 78.9103L102.607 90.2675L104.607 88.7667L96.0823 77.4096Z'
            fill='currentColor'
          />
          <path
            d='M90.4001 81.9022L88.5391 83.5715L98.0205 94.1419L99.8815 92.4727L90.4001 81.9022Z'
            fill='currentColor'
          />
          <path
            d='M85.1996 86.9186L83.4911 88.7439L93.8585 98.4482L95.567 96.6229L85.1996 86.9186Z'
            fill='currentColor'
          />
          <path
            d='M80.369 92.4617L78.8262 94.429L90.0002 103.192L91.5429 101.225L80.369 92.4617Z'
            fill='currentColor'
          />
          <path
            d='M76.083 98.2661L74.7173 100.36L86.6112 108.118L87.977 106.024L76.083 98.2661Z'
            fill='currentColor'
          />
          <path
            d='M72.2525 104.482L71.0745 106.687L83.5989 113.378L84.7769 111.173L72.2525 104.482Z'
            fill='currentColor'
          />
          <path
            d='M69.0111 111.022L68.0298 113.321L81.091 118.895L82.0723 116.595L69.0111 111.022Z'
            fill='currentColor'
          />
          <path
            d='M66.34 117.761L65.563 120.137L79.0601 124.551L79.8371 122.174L66.34 117.761Z'
            fill='currentColor'
          />
          <path
            d='M64.3617 124.786L63.7947 127.221L77.6241 130.442L78.1911 128.007L64.3617 124.786Z'
            fill='currentColor'
          />
          <path
            d='M62.8937 131.89L62.5412 134.365L76.5992 136.367L76.9517 133.892L62.8937 131.89Z'
            fill='currentColor'
          />
          <path
            d='M62.0659 139.085L61.9303 141.582L76.109 142.351L76.2446 139.855L62.0659 139.085Z'
            fill='currentColor'
          />
          <path
            d='M76.0573 145.875L61.8644 146.345L61.9471 148.843L76.14 148.374L76.0573 145.875Z'
            fill='currentColor'
          />
          <path
            d='M76.505 151.961L62.4073 153.666L62.7075 156.148L76.8053 154.443L76.505 151.961Z'
            fill='currentColor'
          />
          <path
            d='M77.389 157.861L63.4929 160.783L64.0074 163.23L77.9035 160.307L77.389 157.861Z'
            fill='currentColor'
          />
          <path
            d='M78.7327 163.806L65.1461 167.934L65.8729 170.326L79.4594 166.198L78.7327 163.806Z'
            fill='currentColor'
          />
          <path
            d='M80.7114 169.44L67.5338 174.733L68.4655 177.053L81.6431 171.76L80.7114 169.44Z'
            fill='currentColor'
          />
          <path
            d='M83.0673 175.049L70.4023 181.471L71.5331 183.701L84.198 177.279L83.0673 175.049Z'
            fill='currentColor'
          />
          <path
            d='M85.9831 180.344L73.923 187.842L75.243 189.965L87.3031 182.468L85.9831 180.344Z'
            fill='currentColor'
          />
          <path
            d='M89.3353 185.365L77.9796 193.89L79.4806 195.89L90.8363 187.364L89.3353 185.365Z'
            fill='currentColor'
          />
          <path
            d='M93.0412 190.074L82.4707 199.555L84.14 201.416L94.7105 191.935L93.0412 190.074Z'
            fill='currentColor'
          />
          <path
            d='M97.1965 194.555L87.4923 204.922L89.3175 206.631L99.0218 196.263L97.1965 194.555Z'
            fill='currentColor'
          />
          <path
            d='M101.725 198.5L92.9619 209.674L94.9292 211.217L103.692 200.043L101.725 198.5Z'
            fill='currentColor'
          />
          <path
            d='M106.512 202.081L98.7547 213.975L100.849 215.341L108.606 203.447L106.512 202.081Z'
            fill='currentColor'
          />
          <path
            d='M111.663 205.279L104.974 217.804L107.179 218.982L113.868 206.456L111.663 205.279Z'
            fill='currentColor'
          />
          <path
            d='M117.142 207.903L111.565 220.962L113.865 221.944L119.441 208.884L117.142 207.903Z'
            fill='currentColor'
          />
          <path
            d='M122.713 210.141L118.296 223.637L120.672 224.415L125.089 210.919L122.713 210.141Z'
            fill='currentColor'
          />
          <path
            d='M128.505 211.877L125.283 225.706L127.718 226.273L130.94 212.444L128.505 211.877Z'
            fill='currentColor'
          />
          <path
            d='M134.394 213.105L132.392 227.163L134.867 227.516L136.869 213.458L134.394 213.105Z'
            fill='currentColor'
          />
          <path
            d='M140.358 213.726L139.589 227.905L142.085 228.04L142.854 213.861L140.358 213.726Z'
            fill='currentColor'
          />
          <path
            d='M148.97 213.772L146.471 213.855L146.94 228.048L149.439 227.965L148.97 213.772Z'
            fill='currentColor'
          />
          <path
            d='M154.94 213.211L152.458 213.511L154.164 227.609L156.646 227.309L154.94 213.211Z'
            fill='currentColor'
          />
          <path
            d='M160.91 212.101L158.463 212.616L161.388 226.512L163.835 225.997L160.91 212.101Z'
            fill='currentColor'
          />
          <path
            d='M166.706 210.55L164.314 211.277L168.44 224.865L170.832 224.138L166.706 210.55Z'
            fill='currentColor'
          />
          <path
            d='M172.349 208.345L170.029 209.277L175.324 222.453L177.644 221.521L172.349 208.345Z'
            fill='currentColor'
          />
          <path
            d='M177.763 205.832L175.534 206.963L181.956 219.628L184.186 218.497L177.763 205.832Z'
            fill='currentColor'
          />
          <path
            d='M182.959 202.745L180.837 204.065L188.338 216.123L190.461 214.802L182.959 202.745Z'
            fill='currentColor'
          />
          <path
            d='M187.861 199.197L185.862 200.697L194.386 212.055L196.385 210.554L187.861 199.197Z'
            fill='currentColor'
          />
          <path
            d='M192.428 195.311L190.567 196.98L200.049 207.551L201.91 205.881L192.428 195.311Z'
            fill='currentColor'
          />
          <path
            d='M196.683 190.949L194.975 192.774L205.342 202.478L207.051 200.653L196.683 190.949Z'
            fill='currentColor'
          />
          <path
            d='M200.537 186.343L198.994 188.31L210.168 197.073L211.711 195.106L200.537 186.343Z'
            fill='currentColor'
          />
          <path
            d='M203.993 181.349L202.627 183.443L214.523 191.199L215.888 189.105L203.993 181.349Z'
            fill='currentColor'
          />
          <path
            d='M206.903 176.069L205.725 178.274L218.249 184.965L219.427 182.76L206.903 176.069Z'
            fill='currentColor'
          />
          <path
            d='M209.386 170.618L208.405 172.918L221.466 178.491L222.447 176.192L209.386 170.618Z'
            fill='currentColor'
          />
          <path
            d='M211.445 164.884L210.668 167.26L224.165 171.673L224.942 169.297L211.445 164.884Z'
            fill='currentColor'
          />
          <path
            d='M212.926 159.129L212.359 161.564L226.188 164.785L226.755 162.35L212.926 159.129Z'
            fill='currentColor'
          />
          <path
            d='M213.96 153.187L213.608 155.662L227.666 157.664L228.018 155.189L213.96 153.187Z'
            fill='currentColor'
          />
          <path
            d='M214.365 147.115L214.229 149.611L228.408 150.381L228.543 147.884L214.365 147.115Z'
            fill='currentColor'
          />
          <path
            d='M228.564 140.573L214.371 141.041L214.453 143.54L228.646 143.072L228.564 140.573Z'
            fill='currentColor'
          />
          <path
            d='M227.906 133.359L213.808 135.064L214.108 137.546L228.206 135.841L227.906 133.359Z'
            fill='currentColor'
          />
          <path
            d='M226.573 126.167L212.679 129.095L213.194 131.541L227.089 128.613L226.573 126.167Z'
            fill='currentColor'
          />
          <path
            d='M224.64 119.191L211.053 123.322L211.78 125.714L225.367 121.583L224.64 119.191Z'
            fill='currentColor'
          />
          <path
            d='M222.12 112.341L208.942 117.633L209.874 119.953L223.051 114.661L222.12 112.341Z'
            fill='currentColor'
          />
          <path
            d='M218.985 105.851L206.32 112.273L207.451 114.503L220.116 108.08L218.985 105.851Z'
            fill='currentColor'
          />
          <path
            d='M215.276 99.5657L203.219 107.066L204.539 109.189L216.597 101.688L215.276 99.5657Z'
            fill='currentColor'
          />
          <path
            d='M211.12 93.5869L199.764 102.113L201.265 104.112L212.621 95.5861L211.12 93.5869Z'
            fill='currentColor'
          />
          <path
            d='M206.394 88.1118L195.822 97.5932L197.492 99.4544L208.064 89.9731L206.394 88.1118Z'
            fill='currentColor'
          />
          <path
            d='M201.224 82.9186L191.517 93.2831L193.342 94.9921L203.049 84.6276L201.224 82.9186Z'
            fill='currentColor'
          />
          <path
            d='M195.609 78.3287L186.847 89.5026L188.814 91.0454L197.577 79.8714L195.609 78.3287Z'
            fill='currentColor'
          />
          <path
            d='M189.614 74.1731L181.857 86.067L183.951 87.4328L191.708 75.5388L189.614 74.1731Z'
            fill='currentColor'
          />
          <path
            d='M183.377 70.5833L176.687 83.1091L178.892 84.2869L185.582 71.761L183.377 70.5833Z'
            fill='currentColor'
          />
          <path
            d='M176.743 67.5214L171.172 80.584L173.472 81.5647L179.042 68.5022L176.743 67.5214Z'
            fill='currentColor'
          />
          <path
            d='M169.885 65.161L165.475 78.6581L167.851 79.4346L172.261 65.9375L169.885 65.161Z'
            fill='currentColor'
          />
          <path
            d='M162.846 63.305L159.624 77.1344L162.059 77.7016L165.281 63.8723L162.846 63.305Z'
            fill='currentColor'
          />
          <path
            d='M155.692 62.0383L153.69 76.0963L156.165 76.4488L158.167 62.3908L155.692 62.0383Z'
            fill='currentColor'
          />
          <path
            d='M148.387 61.4273L147.618 75.606L150.115 75.7413L150.883 61.5626L148.387 61.4273Z'
            fill='currentColor'
          />
          <path
            d='M144.036 84.0791L142.237 84.1385L142.58 94.5333L144.379 94.4739L144.036 84.0791Z'
            fill='currentColor'
          />
          <path
            d='M138.763 84.3355L136.976 84.5508L138.22 94.8759L140.007 94.6606L138.763 84.3355Z'
            fill='currentColor'
          />
          <path
            d='M133.499 85.1372L131.737 85.5082L133.881 95.6846L135.642 95.3136L133.499 85.1372Z'
            fill='currentColor'
          />
          <path
            d='M128.379 86.4778L126.657 87.0009L129.679 96.9526L131.402 96.4296L128.379 86.4778Z'
            fill='currentColor'
          />
          <path
            d='M123.409 88.1379L121.739 88.8089L125.616 98.4591L127.287 97.788L123.409 88.1379Z'
            fill='currentColor'
          />
          <path
            d='M118.555 90.2477L116.95 91.0618L121.654 100.337L123.259 99.5224L118.555 90.2477Z'
            fill='currentColor'
          />
          <path
            d='M113.936 92.7912L112.408 93.7419L117.901 102.573L119.429 101.622L113.936 92.7912Z'
            fill='currentColor'
          />
          <path
            d='M109.502 95.6818L108.062 96.7624L114.305 105.08L115.745 104L109.502 95.6818Z'
            fill='currentColor'
          />
          <path
            d='M105.322 99.045L103.982 100.247L110.927 107.989L112.266 106.787L105.322 99.045Z'
            fill='currentColor'
          />
          <path
            d='M101.543 102.666L100.313 103.98L107.906 111.087L109.136 109.773L101.543 102.666Z'
            fill='currentColor'
          />
          <path
            d='M98.0162 106.695L96.9052 108.111L105.088 114.53L106.199 113.114L98.0162 106.695Z'
            fill='currentColor'
          />
          <path
            d='M94.8542 110.927L93.8709 112.435L102.582 118.117L103.565 116.609L94.8542 110.927Z'
            fill='currentColor'
          />
          <path
            d='M92.1017 115.49L91.2537 117.078L100.428 121.977L101.275 120.389L92.1017 115.49Z'
            fill='currentColor'
          />
          <path
            d='M89.8054 120.176L89.0989 121.831L98.6638 125.913L99.3703 124.258L89.8054 120.176Z'
            fill='currentColor'
          />
          <path
            d='M87.8494 125.091L87.29 126.802L97.1752 130.034L97.7346 128.323L87.8494 125.091Z'
            fill='currentColor'
          />
          <path
            d='M86.3758 130.187L85.9675 131.94L96.0961 134.299L96.5043 132.546L86.3758 130.187Z'
            fill='currentColor'
          />
          <path
            d='M85.268 135.376L85.0142 137.158L95.3102 138.624L95.564 136.842L85.268 135.376Z'
            fill='currentColor'
          />
          <path
            d='M84.6564 140.683L84.5588 142.481L94.9432 143.044L95.0408 141.247L84.6564 140.683Z'
            fill='currentColor'
          />
          <path
            d='M94.9729 145.635L84.5781 145.979L84.6375 147.778L95.0323 147.434L94.9729 145.635Z'
            fill='currentColor'
          />
          <path
            d='M95.2485 149.981L84.9234 151.224L85.1386 153.011L95.4638 151.768L95.2485 149.981Z'
            fill='currentColor'
          />
          <path
            d='M95.9013 154.337L85.7249 156.481L86.0959 158.242L96.2723 156.099L95.9013 154.337Z'
            fill='currentColor'
          />
          <path
            d='M96.9317 158.626L86.9799 161.648L87.503 163.37L97.4548 160.348L96.9317 158.626Z'
            fill='currentColor'
          />
          <path
            d='M98.2744 162.742L88.6222 166.615L89.2925 168.285L98.9447 164.412L98.2744 162.742Z'
            fill='currentColor'
          />
          <path
            d='M100.015 166.74L90.7404 171.445L91.5547 173.05L100.829 168.345L100.015 166.74Z'
            fill='currentColor'
          />
          <path
            d='M102.113 170.587L93.2816 176.079L94.2322 177.608L103.064 172.116L102.113 170.587Z'
            fill='currentColor'
          />
          <path
            d='M104.493 174.3L96.1749 180.543L97.2555 181.983L105.573 175.739L104.493 174.3Z'
            fill='currentColor'
          />
          <path
            d='M107.274 177.777L99.5304 184.719L100.732 186.059L108.476 179.117L107.274 177.777Z'
            fill='currentColor'
          />
          <path
            d='M110.27 180.92L103.158 188.509L104.471 189.74L111.583 182.151L110.27 180.92Z'
            fill='currentColor'
          />
          <path
            d='M113.599 183.856L107.18 192.038L108.596 193.149L115.015 184.967L113.599 183.856Z'
            fill='currentColor'
          />
          <path
            d='M117.083 186.48L111.403 195.191L112.911 196.174L118.591 187.463L117.083 186.48Z'
            fill='currentColor'
          />
          <path
            d='M120.882 188.781L115.982 197.954L117.569 198.802L122.47 189.629L120.882 188.781Z'
            fill='currentColor'
          />
          <path
            d='M124.739 190.682L120.657 200.247L122.312 200.954L126.394 191.389L124.739 190.682Z'
            fill='currentColor'
          />
          <path
            d='M128.824 192.342L125.59 202.226L127.3 202.786L130.535 192.901L128.824 192.342Z'
            fill='currentColor'
          />
          <path
            d='M133.053 193.553L130.692 203.682L132.445 204.091L134.806 193.962L133.053 193.553Z'
            fill='currentColor'
          />
          <path
            d='M137.366 194.388L135.897 204.684L137.679 204.938L139.148 194.642L137.366 194.388Z'
            fill='currentColor'
          />
          <path
            d='M141.748 194.93L141.186 205.315L142.983 205.412L143.546 195.028L141.748 194.93Z'
            fill='currentColor'
          />
          <path
            d='M147.937 195.083L146.138 195.142L146.481 205.537L148.28 205.477L147.937 195.083Z'
            fill='currentColor'
          />
          <path
            d='M152.287 194.632L150.5 194.848L151.748 205.173L153.535 204.957L152.287 194.632Z'
            fill='currentColor'
          />
          <path
            d='M156.611 193.825L154.849 194.196L156.993 204.372L158.754 204.001L156.611 193.825Z'
            fill='currentColor'
          />
          <path
            d='M160.879 192.668L159.156 193.191L162.179 203.143L163.901 202.62L160.879 192.668Z'
            fill='currentColor'
          />
          <path
            d='M164.976 191.038L163.306 191.709L167.183 201.359L168.853 200.688L164.976 191.038Z'
            fill='currentColor'
          />
          <path
            d='M168.947 189.15L167.341 189.964L172.043 199.241L173.649 198.427L168.947 189.15Z'
            fill='currentColor'
          />
          <path
            d='M172.761 186.992L171.232 187.942L176.721 196.776L178.25 195.826L172.761 186.992Z'
            fill='currentColor'
          />
          <path
            d='M176.305 184.391L174.865 185.472L181.108 193.79L182.548 192.709L176.305 184.391Z'
            fill='currentColor'
          />
          <path
            d='M179.588 181.552L178.248 182.754L185.192 190.495L186.532 189.293L179.588 181.552Z'
            fill='currentColor'
          />
          <path
            d='M182.709 178.387L181.479 179.701L189.072 186.809L190.302 185.495L182.709 178.387Z'
            fill='currentColor'
          />
          <path
            d='M185.524 175.094L184.413 176.51L192.596 182.929L193.707 181.513L185.524 175.094Z'
            fill='currentColor'
          />
          <path
            d='M187.97 171.444L186.987 172.952L195.699 178.633L196.682 177.125L187.97 171.444Z'
            fill='currentColor'
          />
          <path
            d='M190.123 167.569L189.275 169.157L198.449 174.056L199.297 172.468L190.123 167.569Z'
            fill='currentColor'
          />
          <path
            d='M192.002 163.606L191.295 165.261L200.86 169.343L201.567 167.688L192.002 163.606Z'
            fill='currentColor'
          />
          <path
            d='M193.423 159.429L192.864 161.14L202.749 164.372L203.308 162.661L193.423 159.429Z'
            fill='currentColor'
          />
          <path
            d='M194.574 155.198L194.165 156.951L204.294 159.31L204.702 157.557L194.574 155.198Z'
            fill='currentColor'
          />
          <path
            d='M195.261 150.829L195.008 152.611L205.304 154.078L205.557 152.296L195.261 150.829Z'
            fill='currentColor'
          />
          <path
            d='M195.624 146.527L195.527 148.325L205.911 148.888L206.009 147.091L195.624 146.527Z'
            fill='currentColor'
          />
          <path
            d='M205.976 141.735L195.582 142.078L195.641 143.877L206.036 143.534L205.976 141.735Z'
            fill='currentColor'
          />
          <path
            d='M205.448 136.487L195.123 137.731L195.339 139.518L205.664 138.274L205.448 136.487Z'
            fill='currentColor'
          />
          <path
            d='M204.493 131.246L194.317 133.389L194.688 135.151L204.864 133.007L204.493 131.246Z'
            fill='currentColor'
          />
          <path
            d='M203.122 126.125L193.17 129.147L193.693 130.869L203.645 127.847L203.122 126.125Z'
            fill='currentColor'
          />
          <path
            d='M201.273 121.135L191.621 125.008L192.291 126.679L201.943 122.806L201.273 121.135Z'
            fill='currentColor'
          />
          <path
            d='M198.992 116.337L189.717 121.041L190.531 122.647L199.806 117.943L198.992 116.337Z'
            fill='currentColor'
          />
          <path
            d='M196.314 111.792L187.482 117.283L188.432 118.811L197.264 113.32L196.314 111.792Z'
            fill='currentColor'
          />
          <path
            d='M193.29 107.436L184.972 113.679L186.052 115.119L194.37 108.876L193.29 107.436Z'
            fill='currentColor'
          />
          <path
            d='M189.868 103.426L182.127 110.372L183.329 111.712L191.07 104.766L189.868 103.426Z'
            fill='currentColor'
          />
          <path
            d='M186.049 99.6823L178.941 107.274L180.256 108.504L187.363 100.912L186.049 99.6823Z'
            fill='currentColor'
          />
          <path
            d='M181.999 96.3444L175.581 104.527L176.997 105.638L183.416 97.4554L181.999 96.3444Z'
            fill='currentColor'
          />
          <path
            d='M177.68 93.3001L171.998 102.011L173.506 102.994L179.188 94.2834L177.68 93.3001Z'
            fill='currentColor'
          />
          <path
            d='M173.018 90.663L168.118 99.8369L169.706 100.685L174.606 91.511L173.018 90.663Z'
            fill='currentColor'
          />
          <path
            d='M168.169 88.4866L164.087 98.0515L165.743 98.758L169.825 89.1931L168.169 88.4866Z'
            fill='currentColor'
          />
          <path
            d='M163.199 86.6702L159.965 96.5544L161.676 97.1142L164.91 87.23L163.199 86.6702Z'
            fill='currentColor'
          />
          <path
            d='M158.057 85.3493L155.695 95.4778L157.448 95.8866L159.81 85.758L158.057 85.3493Z'
            fill='currentColor'
          />
          <path
            d='M152.798 84.4978L151.332 94.7938L153.114 95.0476L154.58 84.7516L152.798 84.4978Z'
            fill='currentColor'
          />
          <path
            d='M147.587 84.0619L147.025 94.4463L148.822 94.5436L149.385 84.1592L147.587 84.0619Z'
            fill='currentColor'
          />
        </svg>
        <svg
          viewBox='0 0 414 283'
          className={styles.logoText}
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M39.6 74.7L35.1 192.3H44.1L39.6 74.7ZM45.2 224.1H33.6L31.4 280.6H0L17.6 2.09998H64L82.7 280.6H47.5L45.2 224.1Z'
            fill='currentColor'
          />
          <path
            d='M85.3 2.09998H145.6V35.4H120.9V117H141.8L142.2 151.1H120.9V280.6H85.3V2.09998Z'
            fill='currentColor'
          />
          <path
            d='M151.2 2.09998H192.4L199.1 144L205.8 2.09998H246.3V280.6H215.6V118.1L204.7 280.6H192L180.7 118.1V280.6H151.2V2.09998Z'
            fill='currentColor'
          />
          <path
            d='M288.9 74.7L284.4 192.3H293.4L288.9 74.7ZM294.6 224.1H283L280.8 280.6H249.4L267 2.09998H313.4L332 280.6H296.8L294.6 224.1Z'
            fill='currentColor'
          />
          <path
            d='M378.4 244.7V150.7H414V245.4C414 266 403.5 282.5 378.1 282.5H372.1C344.8 282.5 333.9 267.9 333.9 242.4V39.1C333.9 16.3 344 0.199982 372.1 0.199982H378.1C403.6 0.199982 414 14.4 414 35.8V121.5H378.4V36.9C378.4 33.2 377.3 31.3 374.7 31.3C372.1 31.3 371 33.2 371 36.9V244.7C371 248.8 372.1 250.7 374.7 250.7C377.3 250.7 378.4 248.8 378.4 244.7Z'
            fill='currentColor'
          />
        </svg>
      </Link>
      <div className={styles.menu}>
        <Link
          to='/journal'
          className={styles.menuLink}
          activeClassName={styles.activeLink}
          partiallyActive={styles.activeLink}
        >
          Journal
        </Link>
        <Link
          to='/collective'
          className={styles.menuLink}
          activeClassName={styles.activeLink}
        >
          Collective
        </Link>
        <Link
          to='/about'
          className={styles.menuLink}
          activeClassName={styles.activeLink}
        >
          About
        </Link>
        <Link
          to='/shop'
          className={styles.menuLink}
          activeClassName={styles.activeLink}
        >
          Shop
        </Link>
      </div>
    </header>
  )
}

export default Header
